import React from "react";

function Footer() {
  return (
    <footer>
      <div>
        <h1>TechyStar</h1>
        <p>@all right reserved</p>
      </div>
      <div>
        <h5>follow Us</h5>
        <div>
          <a href="https:/youtube.com/6pakeprogrammer" target="blank">
            Youtube
          </a>
          <a href="https:/instagram.com/mr.ak__7777" target="blank">
            Instagram
          </a>
          <a href="https:/github.com/anil_kumawat" target="blank">
            Github
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
